import { Markdown } from "@corpuscomplete/web/components/common/markdown";
import { Badge } from "@corpuscomplete/web-ui/components/badge";
import { Button } from "@corpuscomplete/web-ui/components/button";
import { Text as TextComponent } from "@corpuscomplete/web-ui/components/text";
import type { TextPart, UIMessage } from "ai";
import { AgentTools } from "@corpuscomplete/core-ui/ai/agent/tools";
import { cn } from "@corpuscomplete/web-ui/lib/utils";

export namespace MessagePart {
  export function ToolApproval({
    toolName,
    toolCallId,
    messageId,
    toolOutput,
    disabled = false,
    className,
  }: {
    toolName: string;
    toolCallId: string;
    messageId: string;
    toolOutput: { approved: boolean } | undefined;
    disabled?: boolean;
    className?: string;
  }) {
    const { submit, canSubmit = true } = AgentTools.useToolSubmit<{ approved: boolean }>({
      toolName,
      toolCallId,
      messageId,
    });

    if (toolOutput !== undefined) {
      return (
        <div className="mb-4 flex flex-row justify-start">
          {toolOutput.approved ? (
            <Badge variant="default">Approved</Badge>
          ) : (
            <Badge variant="destructive">Rejected</Badge>
          )}
        </div>
      );
    }

    function handleSubmit(approved: boolean) {
      submit({ approved });
    }

    return (
      <div className={cn("flex flex-row justify-start gap-1", className)}>
        <Button
          onClick={() => handleSubmit(false)}
          variant="outline"
          disabled={disabled || !canSubmit}
        >
          <TextComponent variant="sm">Reject</TextComponent>
        </Button>
        <Button
          onClick={() => handleSubmit(true)}
          variant="default"
          disabled={disabled || !canSubmit}
        >
          <TextComponent variant="sm">Approve</TextComponent>
        </Button>
      </div>
    );
  }

  export function Text({
    role,
    part,
    isStreaming,
  }: {
    role: UIMessage["role"];
    part: TextPart;
    isStreaming?: boolean;
  }) {
    if (role === "user") {
      return (
        <div className="mb-4 flex flex-row justify-end">
          <div className="max-w-[80%] rounded-lg bg-muted px-4 py-2">
            <TextComponent variant="sm" className="text-foreground">
              {part.text}
            </TextComponent>
          </div>
        </div>
      );
    } else {
      return (
        <div className="mb-4">
          <Markdown isAnimating={isStreaming}>{part.text}</Markdown>
        </div>
      );
    }
  }
}
